import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { CheckIcon } from './Icons';
const faqs = [{
  q: '"No tengo habilidades manuales, ¿puedo hacerlo?"',
  a: 'El método está diseñado desde "Nivel 0". Si puedes atarte los zapatos, puedes crear un imperio con macramé.'
}, {
  q: '"¿Realmente ayuda con la ansiedad?"',
  a: 'Sí. El movimiento bilateral estimula ambos hemisferios del cerebro, proporcionando un alivio similar a la meditación profunda pero con un resultado físico tangible.'
}, {
  q: '"¿Cómo recibiré el libro?"',
  a: 'Recibirás un correo electrónico con el acceso inmediato tras el pago. Puedes leerlo en tu móvil, tablet u ordenador.'
}];
export const FAQSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-[#f4ece3]" ref={ref} data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <div className="text-center mb-8 md:mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-serif text-brown mb-4" data-id="element-18">
            Preguntas Frecuentes
          </h2>
          <div className="w-12 h-px bg-gold mx-auto" data-id="element-19"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8
      }} className="space-y-4" data-id="element-20">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-beige rounded-sm overflow-hidden shadow-sm" data-id="element-21">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-22">
                <span className="font-serif text-lg text-charcoal" data-id="element-23">
                  {faq.q}
                </span>
                <span className="text-gold text-2xl font-light ml-4" data-id="element-24">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>

              <AnimatePresence data-id="element-25">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-26">
                    <div className="px-6 pb-5 pt-2 border-t border-beige/30 flex items-start text-charcoal/70 font-light leading-relaxed" data-id="element-27">
                      <CheckIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-1" data-id="element-28" />
                      <p data-id="element-29">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </motion.div>
      </div>
    </section>;
};